import React from 'react';
import { Tag } from 'antd';
import { FilterTypes } from '../../FilterCommon/Filter';
import { isErrorPc } from '@/component/PageComponent/errorPc';
import { SelectModalCommonPc } from '../Common/SelectListModalPc';
import { getGoodsPromotion, GoodsPromotionListResp, GoodsPromotionDetailResp, GoodsPromotionItem } from './service';
import { compact } from 'lodash';
import { getSearchTimestamp } from '@/component/common/report/report';


export interface FilterGoodsPromotionProps {
  onChange? (value: any, option: any): void
  value: any
  promotion_type?: string;
}

type RespListRow = GoodsPromotionListResp['list'][0];

export function FilterGoodsPromotion(props: FilterGoodsPromotionProps) {

  const {...rest} = props
  let listKey = 'promotion_id'

  const getList = async (params: any)=>{
    let res =  await getGoodsPromotion<GoodsPromotionListResp>({
      action: "index",
      ...params,
      page: params.page - 1,
     })
    if(isErrorPc(res, {codeKey: "status", codeValue: 'success', messageKey: 'message'})){
      return {
        list: [],
        count: 0,
      }
    }
    const dataList = res.data?.data?.list || [];
    return {
      list: dataList.map(item => ({...item, label: item.promotion_name, value: item.promotion_id})),
      count: res.data.data.count
    }
  }

  const getDetail = async (params: { ids: string[] }) => {
    const { ids } = params;
    const promises = ids.map((id) => {
      return getGoodsPromotion<GoodsPromotionDetailResp>({
        action: props?.promotion_type,
        id
      })
    })
    const results = await Promise.all(promises);
    const detailData = results.map((res) => {
      if(isErrorPc(res, {codeKey: "status", codeValue: 'success', messageKey: 'message'})) return undefined
      const dataItem = res.data?.data.info;
      return {
        label: dataItem.promotion_name,
        value: dataItem.promotion_id
      }
    })
    return compact(detailData)
  }

  const getComponentKey = () => {
    let componentKey = 'FilterGoodsPromotion';
    const timeStamp = getSearchTimestamp();
    if (timeStamp) {
      componentKey = componentKey + timeStamp
    }
    return componentKey
  }

  return (
    <SelectModalCommonPc<RespListRow>
      {...rest} 
      listKey={listKey}
      getList={getList}
      getDetail={getDetail}
      componentKey={getComponentKey()}
      SelectProps={{
        placeholder: '选择活动',
        mode: 'multiple',
      }}
      SelectListModalProps={{
        listKey:listKey,
        getList: getList,
        type:'checkbox',
        title:'选择活动',
        filterProps: {
          filters: [
            { type: FilterTypes.Input, dataIndex: 'kw',placeholder: '活动名称'},
            { type: FilterTypes.PromotionType, dataIndex: 'promotion_type', mode: undefined, allowClear: true},
            { type: FilterTypes.DatePick, dataIndex: 'begin_date', placeholder: '开始日期'},
            { type: FilterTypes.DatePick, dataIndex: 'begin_date_end', placeholder: '截止日期' },
            { type: FilterTypes.ClientType, dataIndex: 'type_id_str', placeholder: '客户类型', mode: undefined},
            { type: FilterTypes.ClientArea, dataIndex: 'area_id_str', placeholder: '客户地区', multiple: false },
            { type: FilterTypes.ActivityStatus, dataIndex: 'promotion_status', mode: undefined, allowClear: true, valueType: 'string' },
            { type: FilterTypes.Sort, dataIndex: 'sort', mode: undefined, allowClear: true},
            { type: FilterTypes.PutAway, dataIndex: 'putaway', mode: undefined, allowClear: true, placeholder: '上架下架' },
          ],
        },
        columns: [
          {
            width: 50,
            dataIndex: 'sequence',
            render: (text: string, record: RespListRow, index: number) => {
              return index + 1;
            }
          },
          { width: '20%', title: '促销类型', dataIndex: "promotion_type_name" },
          { width: '20%', title: '创建时间', dataIndex: "create_date" },
          { 
            width: '20%', 
            title: '活动标题', 
            dataIndex: "promotion_name",
            render: (text: string, row: RespListRow) => {
              return (
                <div>
                  <Tag color={row.promotion_status == 'doing' ? 'green' : ''}>{row.promotion_status_name}</Tag>
                  <span style={{ marginLeft: 5 }}>{row.promotion_name}</span>
                </div>
              )
            }
          },
          { 
            width: '20%', 
            title: '开始时间/结束时间', 
            dataIndex: "begin_date", 
            render: (text: string, record: RespListRow) => {
              return (
                <div>
                  <div>{`${record.begin_date} ~ ${record.end_date}`}</div>
                </div>
              )
            }
          }, 
          { 
            width: '20%', 
            title: '上架下架', 
            dataIndex: "putaway",
            render: (text: string) => {
              return text == 'T' ? '上架' : '下架'
            }
          },
        ]
      }}
    />
  )
}
